module.exports = __webpack_public_path__ + "img/Semper_Fi_Cycle@1x.4b14d9d5.png";